module.exports = __webpack_public_path__ + "static/media/rice.178a4ad6.png";